/**
 * Icon Variants
 *
 * CVA variants for the Icon component.
 * Exported separately to comply with React Fast Refresh requirements.
 *
 * @see Icon.tsx for component implementation
 */

import {cva} from 'class-variance-authority';

export const iconVariants = cva('shrink-0', {
  variants: {
    /**
     * Icon size - semantic names or Tailwind scale numbers
     */
    size: {
      // Semantic sizes
      xs: 'h-3 w-3',
      sm: 'h-4 w-4',
      md: 'h-5 w-5',
      lg: 'h-6 w-6',
      xl: 'h-8 w-8',
      '2xl': 'h-10 w-10',
      '3xl': 'h-12 w-12',
      // Numeric sizes (Tailwind scale)
      3: 'h-3 w-3',
      3.5: 'h-3.5 w-3.5',
      4: 'h-4 w-4',
      5: 'h-5 w-5',
      6: 'h-6 w-6',
      7: 'h-7 w-7',
      8: 'h-8 w-8',
      10: 'h-10 w-10',
      12: 'h-12 w-12',
      16: 'h-16 w-16',
    },
    /**
     * Icon color
     */
    color: {
      inherit: 'text-inherit',
      current: 'text-current',
      foreground: 'text-foreground',
      muted: 'text-muted-foreground',
      primary: 'text-primary',
      secondary: 'text-secondary',
      accent: 'text-[hsl(var(--primary-color))]',
      destructive: 'text-destructive',
      success: 'text-green-500',
      warning: 'text-yellow-500',
      white: 'text-primary-foreground',
    },
    /**
     * Animation
     */
    animate: {
      none: '',
      spin: 'animate-spin',
      pulse: 'animate-pulse',
      bounce: 'animate-bounce',
    },
  },
  defaultVariants: {
    size: 'md',
    color: 'current',
    animate: 'none',
  },
});
